import { root, id } from './request';

export const request = {
  ...root,
  id,
};
